export default "__VITE_ASSET__6e11b841__"